<template>
    <CRow class="mt-3">
        <CCol col="12" sm="12" md="10" lg="7" xl="6" class="mx-auto">
            <ValidationObserver class="p-2 b-a-2 bg-white" tag="div" ref="form" v-slot="{ handleSubmit, invalid }">
                <Loading />
                <Message />

                <CForm method="post" @submit.prevent="handleSubmit(submit)">
                    <CRow>
                        <CCustomInput
                            col="12" sm="6"
                            vid="website"
                            :name="$t('store.website')"
                            rules="required|url"
                            required
                            ltr
                            v-model="store.website"
                        />
                        <CCustomInput
                            col="12" sm="6"
                            vid="name"
                            :name="$t('store.name')"
                            rules="required"
                            required
                            v-model="store.name"
                        />

                        <CCustomSelect
                            sm="12" md="6"
                            v-model="store.category_id"
                            :options="selectableCategoriesWithNull"
                            vid="category_id"
                            required
                            rules="required"
                            :name="$t('category._')"
                        />

                        <CCustomSearchableInput
                            v-if="$policy('store').create_any_or_group && !store.id"
                            col="12" md="6"
                            vid="user_id"
                            :name="$t('attributes.created_for')"
                            v-model="userId"
                            required
                            rules="required"
                            :items="selectableUsers"
                        />

                        <CCustomTextarea
                            rows="5"
                            sm="12"
                            :name="$t('store.description')"
                            vid="description"
                            v-model="store.description"
                            rules="required"
                            required
                        />
                    </CRow>

                    <CRow>
                        <CCustomInput
                            sm="12" md="6"
                            vid="cookie_lifetime"
                            :name="$t('store.cookie_period')+'('+$t('time.day')+')'"
                            rules="required|numeric|min_value:30"
                            required
                            ltr
                            v-model="store.cookie_lifetime"
                        />
                        <CCustomInput
                            sm="12" md="6"
                            vid="conversion_locked_after"
                            :name="$t('store.conversion_locked_after')+'('+$t('time.day')+')'"
                            rules="required|numeric|max_value:14"
                            required
                            ltr
                            v-model="store.conversion_locked_after"
                        />

                        <CCustomImageInputFile
                            col="12" sm="6"
                            vid="logo"
                            :name="$t('store.logo')"
                            v-model="store.logo"
                            showImagePreview
                            path="logos"
                        >
                            <template #after-box>
                                <CAlert color="warning" class="font-weight-light mt-3">
                                    <FaIcon icon="exclamation" class="text-warning font-xs" />
                                    {{ $t('logo_should_square') }}
                                </CAlert>
                            </template>
                        </CCustomImageInputFile>

                        <CCol col="12" class="b-t-1 pt-2 mt-3">
                            <CButton :disabled="invalid" type="submit" color="primary" class="px-4 float-right">{{ $t('btn.next_step') }}</CButton>
                            <CButton type="button" @click="prev" color="outline-primary" class="px-4">{{ $t('btn.prev_step') }}</CButton>
                        </CCol>
                    </CRow>
                </CForm>
            </ValidationObserver>
        </CCol>
    </CRow>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { UserSetupStatus, CategoryParent } from '@/constants'

export default {
    name: 'StoreInformation',


    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.fetchStores({
                no_paginate: true
            })

            vm.fetchCategories({
				no_paginate: true,
				parent: {
					slug: CategoryParent.STORE_PARENT
				}
			})
        })
    },

    computed: {
        ...mapGetters({
            store: 'store/firstStore',
            selectableCategoriesWithNull: 'category/selectableCategoriesWithNull',
        }),
        checkStoreInformation() {
            return this.store.name !== null && this.store.category !== null && this.store.website !== null && this.store.description !== null
        },
    },

    methods: {
        ...mapActions({
            fetchStores: 'store/fetch',
			fetchCategories: 'category/fetch',
            edit: 'store/edit',
            create: 'store/create',
            setMsg: 'messageComponent/setMsg',
            resetMsg: 'messageComponent/resetMsg',
            setShowLoading: 'loadingComponent/setShowLoading',
            changeCurrentUserSetupStatus: 'user/changeCurrentUserSetupStatus',
        }),
        submit() {
            this.setShowLoading()
            this.resetMsg()

            const op = this.store.id ? this.edit : this.create

            op(this.store).then(() => {
                this.setShowLoading(false)
                this.changeCurrentUserSetupStatus(UserSetupStatus.SUBMIT_COMMISSION).then(() => {
                    this.setShowLoading(false)
                })
            }).catch(result => {
                if(result.data) {
                    this.$refs.form.setErrors(result.data)
                }
                this.setShowLoading(false)
                this.setMsg({
                    content: this.$t('tags.'+result.tag),
                    type: 'danger'
                })
            })
        },
        prev() {
            this.setShowLoading()

            this.changeCurrentUserSetupStatus(UserSetupStatus.PERSONAL_INFO).then(() => {
                this.setShowLoading(false)
            })
        }
    }
}
</script>